import { z } from "zod";

export const tenantSchema = z.object({
  tenantId: z.string(),
  name: z.string(),
});

export const tenantsResponseSchema = z.object({
  tenants: z.array(tenantSchema),
  primaryTenantId: z.string(),
});

export const selectTenantResponseSchema = z.object({
  success: z.boolean(),
  idToken: z.string().nullable().optional(),
  accessToken: z.string(),
  refreshToken: z.string(),
  challengeName: z.string().nullable().optional(),
  session: z.string().nullable().optional(),
  message: z.string().nullable().optional(),
  tenants: z.array(z.unknown()).optional(),
  selectedTenantId: z.string(),
});

export type Tenant = z.infer<typeof tenantSchema>;
export type TenantsResponse = z.infer<typeof tenantsResponseSchema>;
export type SelectTenantResponse = z.infer<typeof selectTenantResponseSchema>;
